export default __webpack_public_path__ + "static/media/Aura-Egg__48.8cb17deb.png";